<template>
  <div class="page page-uldinfo">
    <div class="uldinfo-desc" data-translation-element="uldinfo">Üldinfo</div>
    <hr/>
    <div class="uldinfo-contact-social">
        <div class="uldinfo-contact">
            <div><Icon name="phone"/><label>+372 603 4999</label></div>
            <div><Icon name="email"/><label>info@ulemiste.ee</label></div>
        </div>
        <div class="uldinfo-social">
            <div>
                <div class="qr" v-html="qrFacebook"></div>
                <div>
                    <h3>Facebook</h3>
                    <label>@UlemisteKeskus</label>
                </div>
            </div>
            <div>
                <div class="qr" v-html="qrInsta"></div>
                <div>
                    <h3>Instagram</h3>
                    <label>@ulemiste_keskus</label>
                </div>
            </div>
            <div>
                <div class="qr" v-html="qrWeb"></div>
                <div>
                    <h3 data-translation-element="uldinfo-koduleht">Koduleht</h3>
                    <label>ulemiste.ee</label>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data () {
        return {
            qrFacebook: null,
            qrInsta: null,
            qrWeb: null
        }
    },
    mounted () {
        const QRCode = require("qrcode-svg");
        this.qrFacebook = new QRCode({content: "https://fb.com/Ulemistekeskus/", container: "svg-viewbox", padding: 0}).svg();
        this.qrInsta = new QRCode({content: "https://instagr.am/ulemiste_keskus/", container: "svg-viewbox", padding: 0}).svg();
        this.qrWeb = new QRCode({content: "https://ulemiste.ee", container: "svg-viewbox", padding: 0}).svg();
    }
}
</script>

<style lang="less">
    @import '../css/variables';
    @import '../css/responsive';

    .uldinfo-contact {
        display: flex;
        align-items: center;
        font-size: 1.4rem;
        font-weight: 500;
        padding: 6rem 0;

        & > div {
            display: flex;
            align-items: center;
            margin-right: 3.3rem;
        }

        .icon {
            height: 1.7rem;
            margin-right: 0.9rem;
        }
    }

    .uldinfo-social {
        display: flex;
        justify-content: space-between;

        h3 {
            font-size: 2.4rem;
            font-weight: 400;
            margin-bottom: 0.4rem;
            margin-top: 0;
        }

        .qr {
            width: 5rem;
            height: 5rem;
            margin-right: 0.8rem;
            padding-top: 0.4rem;
        }

        & > div {
            display: flex;
            align-items: flex-start;
        }
    }

    @media @portrait {
        .uldinfo-desc {
            max-width: 60ch;
        }
        .uldinfo-contact-social {
            display: flex;
            flex-direction: row-reverse;
            justify-content: space-between;
            align-items: flex-end;

            .uldinfo-social > div {
                margin-right: 4rem;
            }
            .uldinfo-contact {
                flex-direction: column;
                padding-bottom: 0 !important;

                & > div {
                    margin-top: 2rem;
                }
            }
        }
    }

</style>